import { useEffect, useState } from "react";
import { Globe } from "lucide-react";
import { api } from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const names = typeof Intl !== "undefined" && Intl.DisplayNames ? new Intl.DisplayNames(["en"], { type: "language" }) : null;
export const langName = (code) => {
  try { return (names && names.of(code)) || code; } catch { return code; }
};

export default function LanguageSelect({ value, onChange }) {
  const [langs, setLangs] = useState([]);

  useEffect(() => {
    api.get("/books/languages").then((r) => setLangs(r.data.languages)).catch(() => {});
  }, []);

  const total = langs.reduce((a, l) => a + l.count, 0);

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="md:w-56 rounded-full font-ui text-sm" data-testid="language-select">
        <Globe className="w-4 h-4 mr-2 text-muted-foreground" />
        <SelectValue placeholder="language" />
      </SelectTrigger>
      <SelectContent className="font-ui max-h-80">
        <SelectItem value="all" data-testid="language-option-all">
          All languages {total ? <span className="opacity-60 ml-1">{total.toLocaleString()}</span> : null}
        </SelectItem>
        {(langs.length ? langs : [{ code: "en", count: null }]).map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`language-option-${l.code}`}>
            {langName(l.code)} {l.count != null && <span className="opacity-60 ml-1">{l.count.toLocaleString()}</span>}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
